export default class RenderLoop {
    constructor(callback, enabled = true) {
        this._enabled = enabled;
        this._callback = callback;
        this._executeThis = this._execute.bind(this);

        if (enabled) {
            this._frame_request = requestAnimationFrame(this._executeThis);
        }
    }

    dispose() {
        if (this._frame_request !== undefined) {
            cancelAnimationFrame(this._frame_request);
        }
    }

    _execute() {
        if (this._enabled) {
            this._frame_request = requestAnimationFrame(this._executeThis);
        }

        this._callback();
    }

    set enabled(enabled) {
        if (this._enabled == enabled) return;
        this._enabled = enabled;

        if (enabled) {
            this._frame_request = requestAnimationFrame(this._executeThis);
        } else {
            if (this._frame_request !== undefined) {
                cancelAnimationFrame(this._frame_request);
                this._frame_request = undefined;
            }
        }
    }

    get enabled() {
        return this._enabled;
    }
}
